import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Col,
  Row,
  Card,
  Avatar,
  Button,
  Modal,
  Typography,
  Form,
  Input,
  notification,
  Upload,
  Select,
} from "antd";
import { UserOutlined, EditOutlined, CameraOutlined } from "@ant-design/icons";
import { isEmpty, isUndefined, first } from "lodash";
import config from "../../Services/apiEndPoints";
import actions from "../../redux/donorDetails/actions";
import myDonationsActions from "../../redux/myDonations/actions";
import axiosInstance from "../../Services/axiosIntercepter";
import studentActions from "../../redux/studentDetails/actions";
import { genderList } from "../Examination/const";

const { Paragraph } = Typography;

const ProfileDetails = () => {
  const { Option } = Select;
  const dispatch = useDispatch();
  const [profileForm] = Form.useForm();
  const [openModal, setOpenModal] = useState(false);

  const student_Id = localStorage.getItem("Student_Id");
  const loginType = localStorage.getItem("loginType");
  const { successMessage, errorMessage, actionType } = useSelector(
    (state) => state.donor
  );
  const { myDonationsList: donorDetails } = useSelector(
    (state) => state.myDonations
  );
  const {
    studentDetails,
    successMessage: studentSuccMsg,
    errorMessage: studentErrMsg,
    actionType: studentActType,
  } = useSelector((state) => state.student);
  const donorId = localStorage.getItem("donorId");
  const typeOfUser =
    sessionStorage.getItem("typeOfUser") || localStorage.getItem("typeOfUser");

  const classList = [
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
  ];

  useEffect(() => {
    if (!isEmpty(donorId) && !isUndefined(donorId)) {
      dispatch(
        myDonationsActions.getMyDonationsList(
          `${config.myDonationsList}?donorId=${donorId}`
        )
      );
    } else if (!isEmpty(student_Id) && !isUndefined(student_Id)) {
      dispatch(
        studentActions.getStudentPersonalDetails(
          `${config.studentGet}?studentId=${student_Id}`
        )
      );
    }
  }, []);

  useEffect(() => {
    if (openModal && !isEmpty(donorId)) {
      profileForm.setFieldsValue({
        ...donorDetails,
      });
    } else if (openModal && !isEmpty(student_Id)) {
      profileForm.setFieldsValue({
        ...studentDetails,
      });
    }
  }, [openModal]);

  useEffect(() => {
    if (actionType === actions.DONOR_DETAILS_UPDATE_SUCCESS) {
      notification.success({
        message: successMessage,
      });
      setTimeout(() => {
        window.location.reload();
      }, 500);
      setOpenModal(false);
    } else if (
      studentActType === studentActions.STUDENT_DETAILS_UPDATE_SUCCESS
    ) {
      notification.success({
        message: studentSuccMsg,
      });
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } else if (
      actionType === actions.DONOR_DETAILS_UPDATE_ERROR ||
      studentActType === studentActions.STUDENT_DETAILS_UPDATE_ERROR
    ) {
      notification.error({
        message: errorMessage || studentErrMsg,
      });
    }
  }, [
    actionType,
    successMessage,
    errorMessage,
    studentSuccMsg,
    studentErrMsg,
    studentActType,
  ]);

  const showModal = () => {
    setOpenModal(true);
  };

  const handleCancel = () => {
    setOpenModal(false);
    profileForm.resetFields();
  };

  const allowedFileTypes = ["image/jpeg", "image/jpg", "image/png"];

  const dummyRequest = async ({ file, onSuccess }) => {
    try {
      if (allowedFileTypes.includes(file.type)) {
        const fileData = file;
        const formData = new FormData();
        formData.append("files", fileData);
        const response = await axiosInstance.post(
          `${config.upload}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (response) {
          const { fileName = "" } = first(
            response?.data?.data?.successfulUploads
          );
          const payload = {
            id: donorId || student_Id,
            profile_url: fileName,
            profile_update: true,
          };
          if (!isEmpty(donorId) && !isUndefined(donorId)) {
            dispatch(actions.updateDonorDetails(config.donorUpdate, payload));
          } else {
            dispatch(
              studentActions.updateStudentDetails(config.studentUpdate, payload)
            );
          }
        } else {
          notification.error({
            message: "Upload went wrong.",
          });
        }
      } else {
        notification.error({
          message: "Please upload the JPEG/JPG/PNG Files",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async () => {
    try {
      const values = await profileForm.validateFields();
      if (!isEmpty(donorId) && !isUndefined(donorId)) {
        values["id"] = donorId;
        dispatch(actions.updateDonorDetails(config.donorUpdate, values));
      } else if (!isEmpty(student_Id) && !isUndefined(student_Id)) {
        values["id"] = student_Id;
        dispatch(
          studentActions.updateStudentDetails(config.studentUpdate, values)
        );
        setOpenModal(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="responsive-container">
      <Card
        className="premium-card"
        title={
          <Typography.Title level={3} style={{ margin: 0 }}>
            Profile
          </Typography.Title>
        }
      >
        <div
          style={{
            padding: "20px",
            borderRadius: "12px",
            backgroundColor: "#ffffff",
            border: "1px solid #f0f0f0",
            marginBottom: "20px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          }}
        >
          <Row gutter={[24, 24]} align="middle">
            <Col xs={24} sm={8} md={6} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <div style={{ position: "relative" }}>
                <Avatar
                  size={120}
                  src={studentDetails?.profile_url || donorDetails?.profile_url}
                  icon={<UserOutlined />}
                />
                <Upload customRequest={dummyRequest} showUploadList={false}>
                  <Button
                    icon={<CameraOutlined />}
                    shape="circle"
                    size="middle"
                    style={{
                      position: "absolute",
                      bottom: "5px",
                      right: "5px",
                      borderColor: "#ff9800",
                      backgroundColor: "#fff",
                      borderWidth: "2px",
                      zIndex: 1,
                    }}
                  />
                </Upload>
              </div>
            </Col>
            <Col xs={24} sm={16} md={18}>
              <div style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "flex-start" }} className="profile-header-info">
                {typeOfUser === "examination" ? (
                  <Typography>
                    <Paragraph strong style={{ fontSize: "18px", marginBottom: "4px" }}>
                      {studentDetails?.name}
                    </Paragraph>
                    <Paragraph style={{ marginBottom: "2px" }}>
                      <strong>School:</strong> {studentDetails?.school_details?.school_name}
                    </Paragraph>
                    <Paragraph style={{ marginBottom: "2px" }}>
                      <strong>Class:</strong> {studentDetails?.school_details?.class}
                    </Paragraph>
                    <Paragraph type="secondary">
                      {studentDetails?.school_details?.school_address}
                    </Paragraph>
                  </Typography>
                ) : (
                  <Typography>
                    <Paragraph strong style={{ fontSize: "20px", marginBottom: "4px" }}>
                      {donorDetails?.name}
                    </Paragraph>
                    <Paragraph type="secondary" style={{ marginBottom: "2px" }}>
                      {donorDetails?.email}
                    </Paragraph>
                    <Paragraph type="secondary">
                      {donorDetails?.mobile}
                    </Paragraph>
                  </Typography>
                )}
              </div>
            </Col>
          </Row>
        </div>
        <div
          style={{
            padding: "20px",
            borderRadius: "12px",
            backgroundColor: "#ffffff",
            border: "1px solid #f0f0f0",
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "24px",
              borderBottom: "1px solid #f0f0f0",
              paddingBottom: "12px",
            }}
          >
            <Typography.Title level={4} style={{ margin: 0 }}>
              Personal Information
            </Typography.Title>
            <Button
              type="primary"
              shape="circle"
              icon={<EditOutlined />}
              onClick={showModal}
              className="premium-button"
              style={{ width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center" }}
            />
          </div>

          <div className="profile-info-content">
            {typeOfUser === "annadhanam" ||
              typeOfUser === "festival" ||
              (typeOfUser === "existingUser" && loginType === "donor") ? (
              <Row gutter={[24, 16]}>
                {[
                  { label: "Full Name", value: donorDetails?.name },
                  { label: "Donor Type", value: donorDetails?.donor_type },
                  { label: "PAN Number", value: donorDetails?.pan_number },
                  { label: "Email", value: donorDetails?.email },
                  { label: "Mobile Number", value: donorDetails?.mobile },
                  { label: "Address 1", value: donorDetails?.address?.address1 },
                  { label: "Address 2", value: donorDetails?.address?.address2 },
                  { label: "Address 3", value: donorDetails?.address?.address3 },
                  { label: "City", value: donorDetails?.address?.city },
                  { label: "Pincode", value: donorDetails?.address?.pincode },
                ].map((item, index) => (
                  <Col xs={24} sm={12} key={index}>
                    <div style={{ marginBottom: "8px" }}>
                      <Typography.Text type="secondary" style={{ fontSize: "12px", display: "block", marginBottom: "2px" }}>
                        {item.label}
                      </Typography.Text>
                      <Typography.Text strong style={{ fontSize: "15px" }}>
                        {item.value || "—"}
                      </Typography.Text>
                    </div>
                  </Col>
                ))}
              </Row>
            ) : (
              <Row gutter={[24, 16]}>
                {[
                  { label: "Student Name", value: studentDetails?.name },
                  { label: "Parent/Guardian Name", value: studentDetails?.fatherormother_name },
                  { label: "Age", value: studentDetails?.age },
                  { label: "Gender", value: studentDetails?.gender },
                  { label: "Mobile No", value: studentDetails?.mobile_number },
                  { label: "Class", value: studentDetails?.school_details?.class },
                  { label: "School", value: studentDetails?.school_details?.school_name },
                  { label: "School Address", value: studentDetails?.school_details?.school_address },
                  { label: "Address", value: studentDetails?.address?.address1 },
                ].map((item, index) => (
                  <Col xs={24} sm={12} key={index}>
                    <div style={{ marginBottom: "8px" }}>
                      <Typography.Text type="secondary" style={{ fontSize: "12px", display: "block", marginBottom: "2px" }}>
                        {item.label}
                      </Typography.Text>
                      <Typography.Text strong style={{ fontSize: "15px" }}>
                        {item.value || "—"}
                      </Typography.Text>
                    </div>
                  </Col>
                ))}
              </Row>
            )}
          </div>
        </div>
      </Card>
      <Modal
        open={openModal}
        title="Update details"
        onCancel={handleCancel}
        footer={
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", padding: "10px 0" }}>
            <Button
              key="cancel"
              onClick={handleCancel}
              style={{ width: "120px", height: "40px", borderRadius: "6px" }}
            >
              Cancel
            </Button>
            <Button
              key="submit"
              type="primary"
              onClick={handleSubmit}
              style={{ width: "120px", height: "40px", border: "none" }}
            >
              Update
            </Button>
          </div>
        }
        width={800}
        centered
      >
        <Form form={profileForm} layout="vertical">
          {typeOfUser === "annadhanam" ||
            typeOfUser === "festival" ||
            typeOfUser === "existingUser" ? (
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="name"
                  label="Full Name"
                  rules={[{ required: true }]}
                  style={{ marginBottom: 12 }}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="pan_number"
                  label="PAN Number"
                  rules={[
                    { required: true, message: "PAN number is required." },
                    {
                      validator: (_, value) => {
                        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
                        return panRegex.test(value)
                          ? Promise.resolve()
                          : Promise.reject("Please enter a valid PAN number.");
                      },
                    },
                  ]}
                  style={{ marginBottom: 12 }}
                >
                  <Input
                    disabled={Boolean(donorDetails?.pan_number)}
                    maxLength={10}
                    onChange={(e) => {
                      const uppercaseValue = e.target.value.toUpperCase();
                      profileForm.setFieldsValue({ pan_number: uppercaseValue });
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    { required: true },
                    {
                      pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "Invalid email format",
                    },
                  ]}
                  style={{ marginBottom: 12 }}
                >
                  <Input type="email" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="mobile"
                  label="Mobile No."
                  rules={[
                    { required: true },
                    { pattern: /^[6-9]\d{9}$/, message: "Enter valid Mobile number" },
                  ]}
                  style={{ marginBottom: 12 }}
                >
                  <Input type="number" maxLength={10} disabled={!isEmpty(donorDetails)} />
                </Form.Item>
              </Col>
              <Col xs={24} md={24}>
                <Form.Item
                  name={["address", "address1"]}
                  label="Address 1"
                  rules={[{ required: true }]}
                  style={{ marginBottom: 12 }}
                >
                  <Input.TextArea rows={2} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name={["address", "address2"]} label="Address 2" style={{ marginBottom: 12 }}>
                  <Input.TextArea rows={1} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name={["address", "address3"]} label="Address 3" style={{ marginBottom: 12 }}>
                  <Input.TextArea rows={1} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name={["address", "city"]}
                  label="City"
                  rules={[{ required: true, message: "Please enter your city" }]}
                  style={{ marginBottom: 12 }}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name={["address", "pincode"]}
                  label="Pincode"
                  rules={[
                    { required: true, message: "Please enter your pincode" },
                    { pattern: /^[1-9][0-9]{5}$/, message: "Enter valid pincode" },
                  ]}
                  style={{ marginBottom: 12 }}
                >
                  <Input maxLength={6} />
                </Form.Item>
              </Col>
            </Row>
          ) : (
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="name"
                  label="Student Name"
                  rules={[{ required: true }]}
                  style={{ marginBottom: 12 }}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="gender"
                  label="Gender"
                  rules={[{ required: true, message: "Gender is required." }]}
                  style={{ marginBottom: 12 }}
                >
                  <Select showSearch placeholder="Select Gender" optionFilterProp="label" className="custom-select">
                    {genderList.map((item, index) => (
                      <Option key={index} value={item.label} label={item.label}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="fatherormother_name" label="Father/Mother Name" style={{ marginBottom: 12 }}>
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="age" label="Age" rules={[{ required: true }]} style={{ marginBottom: 12 }}>
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name={["school_details", "class"]}
                  label="Class"
                  rules={[{ required: true }]}
                  style={{ marginBottom: 12 }}
                >
                  <Select showSearch placeholder="Select class" optionFilterProp="label" className="custom-select">
                    {classList.map((item, index) => (
                      <Option key={index} value={item} label={item}>
                        {item}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="mobile_number"
                  label="Mobile No."
                  rules={[
                    { required: true, message: "Mobile number is required." },
                    { pattern: /^[6-9]\d{9}$/, message: "Please enter valid mobile number." },
                  ]}
                  style={{ marginBottom: 12 }}
                >
                  <Input placeholder="Enter Mobile Number" maxLength={10} />
                </Form.Item>
              </Col>
              <Col xs={24} md={24}>
                <Form.Item
                  name={["address", "address1"]}
                  label="Address"
                  rules={[{ required: true }]}
                  style={{ marginBottom: 12 }}
                >
                  <Input.TextArea rows={2} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name={["address", "city"]}
                  label="City"
                  rules={[{ required: true, message: "City required" }]}
                  style={{ marginBottom: 12 }}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name={["address", "pincode"]}
                  label="Pincode"
                  rules={[{ required: true, message: "Pincode required" }]}
                  style={{ marginBottom: 12 }}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name={["school_details", "school_name"]}
                  label="School Name"
                  rules={[{ required: true, message: "School name required" }]}
                  style={{ marginBottom: 12 }}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name={["school_details", "school_address"]}
                  label="School Address"
                  style={{ marginBottom: 12 }}
                >
                  <Input.TextArea rows={1} />
                </Form.Item>
              </Col>
            </Row>
          )}
        </Form>
      </Modal>
    </div>
  );
};

export default ProfileDetails;
